import { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import { useTranslation } from "react-i18next";

import { Lightbox } from "components/Lightbox";

import { useAppSelector, useAppDispatch } from "store/hooks";
import { selectUserAddressing, setWelcomed, selectFirstPreferredSchool } from "store/slices/user";

import { processApiError } from "utils/processApiError";

import { useSetWelcomedMutation } from "api/generated";

const WelcomeNewUser = () => {
  const { t } = useTranslation(["onboarding"]);
  const preferredSchool = useAppSelector(selectFirstPreferredSchool);
  const userVocative = useAppSelector(selectUserAddressing);
  const dispatch = useAppDispatch();

  const [trigger, { error: apiMutationError }] = useSetWelcomedMutation();
  const [isShown, setShown] = useState(true);
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    if (apiMutationError === undefined) return;

    processApiError(apiMutationError);
  }, [apiMutationError]);

  const handleClose = () => {
    setLoading(true);
    trigger()
      .then(response => {
        if ("data" in response) {
          dispatch(setWelcomed());
          setShown(false);
        } else {
          console.error(response);
        }
      })
      .catch(console.error)
      .finally(() => {
        setLoading(false);
      });
  };

  const translationRoot =
    preferredSchool === null
      ? "welcomeModal.noSchool"
      : typeof preferredSchool.pointsForAcceptance === "number" && preferredSchool.pointsForAcceptance > 0
        ? "welcomeModal.withPoints"
        : "welcomeModal.withoutPoints";

  return (
    // Nadpis je velký centrovaný text bez ilustrace, zůstává proto v těle a jen
    // pojmenuje dialog. [TD-344]
    <Lightbox
      show={isShown}
      onHide={handleClose}
      className={"modal--welcome"}
      bodyTitleId="welcome-new-user-title"
      footer={
        <Button variant="primary" className={"w-100 text-uppercase"} onClick={handleClose} disabled={isLoading}>
          {t(`${translationRoot}.close`)}
        </Button>
      }
    >
      {/* Velikost drží `.fs-16`, ať se sjednocením na `h2` (globálně 17 px) nezmění
          vzhled — původní `h4` měl 16 px ($h4-font-size). [TD-344] */}
      <h2 id="welcome-new-user-title" className={"text-center mb-12px fs-16"}>
        {t(`${translationRoot}.heading`, { name: userVocative })}
      </h2>
      <p
        className={"text-center mt-20px mb-20px quote quote--tight"}
        dangerouslySetInnerHTML={{
          __html: t(`${translationRoot}.content`, {
            schoolName: preferredSchool?.name ?? "",
            count: preferredSchool?.pointsForAcceptance ?? 0,
          }),
        }}
      ></p>
    </Lightbox>
  );
};

export default WelcomeNewUser;
